import { r as registerInstance, h } from './index-16dc7dde.js';
import './utils-15ad90ec.js';
import './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import './isObject-33fa1780.js';
import { h as http } from './http-fdc7ba18.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_commonjsHelpers-ba3f0406.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';
import './isEmpty-b60327cb.js';
import './isTypedArray-dfccd669.js';

const comparisonBarWrapperCss = ":host{box-sizing:border-box;display:block;width:100%;z-index:9900}:host *,:host *::before,:host *::after{box-sizing:inherit}";

let ComparisonBarWrapper = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isPublic = 'false';
    this.breakpointListener = () => {
      {
        this.isMobile = !this.mql.matches;
      }
    };
  }
  async fetchComparisonBarConfigs() {
    try {
      if (!this.config) {
        this.config = await http.get(this.configUrl);
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  setupResizeListeners() {
    {
      this.mql = window.matchMedia('(min-width: 980px)');
      this.isMobile = !this.mql.matches;
      this.mql.addListener(this.breakpointListener);
    }
  }
  componentDidLoad() {
    if (window.isAsco)
      return;
    this.fetchComparisonBarConfigs();
    this.setupResizeListeners();
  }
  disconnectedCallback() {
    if (window.isAsco)
      return;
    this.mql.removeListener(this.breakpointListener);
  }
  render() {
    var _a, _b, _c, _d;
    if (window.isAsco)
      return null;
    return (h("pes-comparison-bar", { localeCode: (_a = this.config) === null || _a === void 0 ? void 0 : _a.localeCode, compareCta: (_b = this.config) === null || _b === void 0 ? void 0 : _b.labels.compareCta, clearListLabel: (_c = this.config) === null || _c === void 0 ? void 0 : _c.labels.clearList, compareLabel: (_d = this.config) === null || _d === void 0 ? void 0 : _d.labels.compareLabel, isConfigured: Boolean(this.config), isMobile: this.isMobile, isPublic: this.isPublic === 'true' }));
  }
};
ComparisonBarWrapper.style = comparisonBarWrapperCss;

export { ComparisonBarWrapper as pes_comparison_bar_wrapper };
